export default __webpack_public_path__ + "static/banque-de-france-feb8161f5e0545435677de49a86c622f.png";